const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/j8vgyc90rtcs1-UZ/image;s=644x461",
        title: "California X 80 привезли из ЕВРОПЫ",
        price: "800 000 сум",
        location: "Ташкент, Яккасарайский район "
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/1dlwvtp1r6np2-UZ/image;s=644x461",
        title: "FatZorb tabiy pereparat.100%orginal.",
        price: "120 000 сум",
        location: "Ташкент, Учтепинский  район ",
    }, {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/j2ykk3p36p9a-UZ/image;s=644x461",
        title: "Швейцарские Часы invikta 53",
        price: "350 у.е.",
        location: "Ташкент,  Мирзо-Улугбекски район ",
    },
]

export default data;